import { gql } from "@uplift-ltd/apollo";

export const REQUIRED_COURSES_VIEW_QUERY = gql`
  query RequiredCoursesView {
    fulfillsRequirements {
      edges {
        node {
          courses {
            edges {
              node {
                id
                slug
                title
              }
            }
          }
          id
          name
          description
          slug
        }
      }
    }
  }
`;
